import React, {Component} from 'react'
import QrReader from 'react-qr-reader'
import {connect} from 'react-redux';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getGestorOperacoes,
    getOperadorEmpresa,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import {showErrorMsg, showSuccessMsg} from '../../util/messagesUtil';
import buscarReserva from '../../actions/reserva/buscarReserva';
import moment from 'moment';
import pt from 'date-fns/locale/pt';
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import {formatarReal} from '../../util/numberUtil';
import embarcarPassageiro from '../../actions/reserva/embarcarPassageiro';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import qs from 'qs';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';

registerLocale('pt', pt);
setDefaultLocale('pt');

class PainelEmbarqueComQrCode extends Component {
    state = {
        reserva: null,
    };

    componentDidMount() {
        this.props.selecionarItinerario(null);
        const parametros = qs.parse(this.props.history.location.search, {ignoreQueryPrefix: true});
        if (parametros.itinerario) {
            this.props.buscarItinerario(this.props.empresaSelecionada.id, parametros.itinerario);
        }
    }

    handleScan = data => {
        if (data) {
            const reservaId = data.substr(44, 9);
            this.setState({buscando: true});
            this.props.buscarReserva(Number(reservaId), this.props.empresaSelecionada.id)
                .then((resp) => {
                    const reserva = resp.payload.data;
                    if (!reserva) {
                        showErrorMsg('Reserva não encontrada.');
                        return;
                    }
                    if (this.props.itinerarioSelecionado.id && reserva.itinerarioId !== this.props.itinerarioSelecionado.id) {
                        showErrorMsg('Reserva não pertence ao itinerário selecionado');
                        return;
                    }
                    if (reserva.situacaoReserva !== 'APROVADO') {
                        showErrorMsg('Reserva não está na situação aprovada.');
                        return;
                    }
                    this.setState({reserva: reserva});
                });
        }
    };

    handleError = err => {
        console.error(err);
    };

    embarcarPassageiro() {
        this.props.embarcarPassageiro(this.props.empresaSelecionada.id, this.state.reserva.id).then(() => {
            showSuccessMsg('Embarque de passageiro realizado com sucesso!');
            this.props.buscarReserva(this.state.reserva.id, this.props.empresaSelecionada.id).then((resp) => {
                this.setState({reserva: resp.payload.data});
            });
        });
    }

    exibirScanner() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
                <QrReader
                    delay={1000}
                    onError={this.handleError}
                    onScan={this.handleScan}
                    style={{width: '50%'}}
                />
            </div>
        );
    }

    exibirDadosReserva() {
        const reserva = this.state.reserva;
        const embarcou = !!reserva.dataHoraEmbarque;

        return (
            <div style={{ marginTop: '16px' }}>
                <div className="vx-qr-card">
                    <div className="vx-qr-grid">
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Data da compra</span>
                            <span className="vx-qr-value">{moment(reserva.dataVenda, 'DD/MM/YYYY').format('DD/MM/YYYY')}</span>
                        </div>
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Data/Hora partida</span>
                            <span className="vx-qr-value">{reserva.dataHoraPartida}</span>
                        </div>
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Nº do pedido</span>
                            <span className="vx-qr-value">{reserva.pedidoId}</span>
                        </div>
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Nº da reserva</span>
                            <span className="vx-qr-value">{reserva.id}</span>
                        </div>
                        <div className="vx-qr-field vx-qr-field--wide">
                            <span className="vx-qr-label">Passageiro</span>
                            <span className="vx-qr-value">{capitalizarTodasPrimeirasLetras(reserva.passageiroDto.nome)}</span>
                        </div>
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Origem</span>
                            <span className="vx-qr-value">{reserva.descCidadeOrigem}</span>
                        </div>
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Destino</span>
                            <span className="vx-qr-value">{reserva.descCidadeDestino}</span>
                        </div>
                        <div className="vx-qr-field vx-qr-field--wide">
                            <span className="vx-qr-label">Vendedor</span>
                            <span className="vx-qr-value">{capitalizarTodasPrimeirasLetras(reserva.nomeVendedor)}</span>
                        </div>
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Valor</span>
                            <span className="vx-qr-value">{formatarReal(reserva.valorTotalReserva)}</span>
                        </div>
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Situação</span>
                            <span className="vx-qr-value">{capitalizarTodasPrimeirasLetras(reserva.situacaoReserva)}</span>
                        </div>
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Data/Hora embarque</span>
                            {embarcou
                                ? <span className="vx-qr-value" style={{color: '#16a34a'}}>{reserva.dataHoraEmbarque}</span>
                                : <span className="vx-qr-value" style={{color: '#dc2626'}}>Não embarcado</span>}
                        </div>
                        <div className="vx-qr-field">
                            <span className="vx-qr-label">Responsável embarque</span>
                            <span className="vx-qr-value">{embarcou ? reserva.nomeResponsavelEmbarque : '—'}</span>
                        </div>
                    </div>

                    {embarcou ? (
                        <div className="vx-qr-success">
                            <i className="material-icons">check_circle</i>
                            <span>Passageiro Embarcado</span>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <button className="vx-btn-primary" onClick={() => this.embarcarPassageiro()}>
                                <i className="material-icons" style={{ fontSize: '18px' }}>transfer_within_a_station</i>
                                Embarcar Passageiro
                            </button>
                        </div>
                    )}
                </div>

                <div className="vx-qr-actions">
                    <button className="vx-btn-secondary" onClick={() => this.setState({reserva: null})}>
                        <i className="material-icons" style={{ fontSize: '16px' }}>crop_free</i>
                        Embarcar outro passageiro
                    </button>
                    <button
                        className="vx-btn-primary"
                        onClick={() => this.props.history.push(`/painel-lista-passageiros?itinerario=${this.state.reserva.itinerarioId}&tipo=embarque`)}
                    >
                        <i className="material-icons" style={{ fontSize: '16px' }}>list</i>
                        Lista de passageiros
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const rota = this.props.itinerarioSelecionado.id ? this.props.itinerarioSelecionado.rotaDto : null;

        return (
            <Autorizacao
                perfisPermitidos={[
                    PERFIL_ADMIN,
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getGestorOperacoes(this.props.empresaSelecionada.id),
                    getAdminEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                    getMotoristaEmpresa(this.props.empresaSelecionada.id),
                    getFiscalEmbarque(this.props.empresaSelecionada.id)
                ]}
                empresaSelecionada={this.props.empresaSelecionada}
            >
                <div className="container-padrao">
                    <Titulo texto="Embarque com QR Code" urlRetorno="/painel-embarque-passageiros" />

                    {rota && (
                        <div className="vx-qr-itinerario-info">
                            <div className="vx-qr-itinerario-rota">
                                <i className="material-icons">route</i>
                                <span>
                                    <strong>{rota.prefixo || 'Prefixo não informado'}: </strong>
                                    {rota.cidadeOrigem.nome}-{rota.cidadeOrigem.uf} → {rota.cidadeDestino.nome}-{rota.cidadeDestino.uf}
                                    {rota.delimitacao ? ` / ${rota.delimitacao}` : ''}
                                </span>
                            </div>
                            <div className="vx-qr-itinerario-hora">
                                <i className="material-icons">schedule</i>
                                <span><strong>Partida:</strong> {this.props.itinerarioSelecionado.dataHoraPartida}</span>
                            </div>
                        </div>
                    )}

                    {this.state.reserva ? this.exibirDadosReserva() : this.exibirScanner()}
                </div>
            </Autorizacao>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        itinerarioSelecionado: state.itinerarioSelecionado,
    }
}

export default connect(mapStateToProps, {
    buscarReserva,
    embarcarPassageiro,
    buscarItinerario,
    selecionarItinerario
})(PainelEmbarqueComQrCode)
